export default __webpack_public_path__ + "static/patriotism-min-e2a2188d8d7c93a20d8a972fb68c1537.png";